import { Component, inject, signal } from '@angular/core';
import { BaseFormLegacyComponent } from '../../../../shared/base-form-legacy.component';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../../../shared/services/app/profile.service';
import { SessionService } from '../../../../shared/services/app/session.service';
import { finalize } from 'rxjs/operators';
import { MESSAGE_ERROR_SERVICE_UNAVAILABLE } from '../../../../shared/consts/messages.const';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RECENT_LOGINS_KEY, RecentLoginsService } from '../../services/recent-logins.service';
import {
  NzAutocompleteComponent,
  NzAutocompleteOptionComponent,
  NzAutocompleteTriggerDirective,
  NzOptionSelectionChange,
} from 'ng-zorro-antd/auto-complete';

@Component({
  selector: 'app-student-auth',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzAlertModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzIconModule,
    NzTypographyModule,
    NzAutocompleteComponent,
    NzAutocompleteOptionComponent,
    NzAutocompleteTriggerDirective,
  ],
  templateUrl: './student-auth.component.html',
  styleUrls: ['./student-auth.component.less', '../login-form.less'],
  providers: [{ provide: RECENT_LOGINS_KEY, useValue: 'recentStudentsFullNames' }, RecentLoginsService],
})
export class StudentAuthComponent extends BaseFormLegacyComponent {
  private authService = inject(AuthService);
  private profileService = inject(ProfileService);
  private session = inject(SessionService);

  protected recentLogins = inject(RecentLoginsService);

  /**
   * Видимость пароля
   */
  passwordVisible = signal(false);
  protected changePasswordVisible = () => this.passwordVisible.update((it) => !it);

  constructor() {
    super();

    this.form = this.fb.group({
      studentFullName: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  onRecentLoginSelected(_: NzOptionSelectionChange): void {
    this.form.patchValue({ password: null }, { emitEvent: false });
  }

  submitForm(): void {
    if (!this.validate()) {
      return;
    }
    this.login();
  }

  /**
   * Аутентификация
   */
  login() {
    if (this.isServiceInProgress) {
      return;
    }

    this.isServiceInProgress = true;
    this.error = '';

    const data = this.form.getRawValue();
    this.authService
      .loginExternal('EXPORT', 0, data)
      .pipe(finalize(() => (this.isServiceInProgress = false)))
      .subscribe({
        next: (res) => {
          this.recentLogins.store(data.studentFullName);

          this.profileService.setToken(res);
          this.router.navigate([this.session.getRedirectURL('/')]);
        },
        error: (error) => {
          this.error = error?.error?.message || MESSAGE_ERROR_SERVICE_UNAVAILABLE;
        },
      });
  }
}
